import Constructable, { Construct } from '../../../../interface/Constructable.js';
import { Disable, Enable } from '../../../../interface/Disableable.js';
import FORMFIELDGROUP from './formfieldgroup/FORMFIELDGROUP.js';
import Hideable, { Hide, Show } from '../../../../interface/Hideable.js';
import CONTENT from '../../../DOM/content/CONTENT.js';
import BUTTONGROUP from '../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import DIV from '../../../DOM/div/DIV.js';
import LEGEND from '../../../DOM/form/fieldset/legend/LEGEND.js';
import NAVBAR from '../../../DOM/nav/navbar/NAVBAR.js';
import { HTMLELEMENT } from '../../../../enums/HTMLELEMENT.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import Reset from '../../../../event/Reset.js';
// Model Structure
export const fieldsetAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const fieldsetData = makeDataStruct([
    ['legend'],
    ['header'],
    ['formfieldgroups', []],
    // ['navheader', {}]
]);
export const fieldsetModel = makeStruct([
    ['attributes', fieldsetAttr],
    ['data', fieldsetData]
]);
// Simplified Model
export function fieldset(name, className, legend, header, formfieldgroups) {
    return {
        attributes: fieldsetAttr(name, className),
        data: fieldsetData(legend, header, formfieldgroups)
    };
}
/** Construct a Form Fieldset that contains form elements */
export default class FIELDSET extends CONTENT {
    constructor(node, model) {
        super(node, HTMLELEMENT.FIELDSET, model);
        this.implement(new Hideable(this));
        this.addConstructor('LEGEND', this.addLegend.bind(this));
        this.addConstructor('FORMFIELDGROUP', this.addFormFieldGroup.bind(this));
        if (model.data.legend) {
            this.addLegend(model.data.legend);
        }
        if (model.data.formfieldgroups) {
            model.data.formfieldgroups.forEach((ffg) => this.addFormFieldGroup(ffg));
        }
    }
    /** Constructs a Legend for this Fieldset that toggles visibility */
    addLegend(model) {
        return this.addChild(new LEGEND(this, model));
    }
    getLegend() {
        const legends = this.get(undefined, 'LEGEND');
        return legends.length > 0 ? legends[0] : null;
    }
    /** Constructs a Form Element Group for this Fieldset */
    addFormFieldGroup(model) {
        return this.addChild(new FORMFIELDGROUP(this, model));
    }
    getFormFieldGroup(name) {
        return this.get(name, 'FORMFIELDGROUP');
    }
    addDiv(model) {
        return this.addChild(new DIV(this, model));
    }
    addButtonGroup(model) {
        return this.addChild(new BUTTONGROUP(this, model));
    }
    addNavBar(model) {
        return this.addChild(new NAVBAR(this, model));
    }
    /** Resets all form fields within this fieldset */
    reset() {
        this.getFormFieldGroup().forEach((formFieldGroup) => formFieldGroup.getFormFields().forEach((formField) => formField.do(new Reset(this))));
    }
    getResults() {
        let results = {};
        this.getFormFieldGroup().forEach((formFieldGroup) => {
            if (!results[formFieldGroup.getName()]) {
                results[formFieldGroup.getName()] = [];
            }
            results[formFieldGroup.getName()].push(formFieldGroup.getResults());
        });
        return results;
    }
}
export { Constructable, Construct, Disable, Enable, FORMFIELDGROUP, Hide, Hideable, Show };
